/** @jsxImportSource @emotion/react */
import React from "react";
import {
  TeleportConfigNode,
  Vector3,
} from "../../../../usecases/HomeConfig/types";
import { Vector3Input } from "../../../Vector3Input";

export interface TeleportNodeEditorProps {
  node: TeleportConfigNode;
  onChange: (updater: (node: TeleportConfigNode) => TeleportConfigNode) => void;
}

export const TeleportNodeEditor = ({
  node,
  onChange,
}: TeleportNodeEditorProps) => {
  const handleChangeLocation = (location: Vector3) => {
    onChange((current) => {
      return { ...current, location };
    });
  };

  const handleChangeRotation = (rotation: Vector3) => {
    onChange((current) => {
      return { ...current, rotation };
    });
  };

  // NOTE: A fragment, not a Space — Vector3Input lays itself out on the node
  // block's grid, and an inline-flex wrapper would shrink that grid to content.
  return (
    <React.Fragment>
      <Vector3Input
        label="Location"
        value={node.location}
        onChange={handleChangeLocation}
      />
      <Vector3Input
        label="Rotation"
        value={node.rotation}
        onChange={handleChangeRotation}
      />
    </React.Fragment>
  );
};
